/** The events row piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { EventsRowEvents } from './contract';
import { EventsRowView } from './EventsRowView';
import { useEventsRow } from './useEventsRow';

export function EventsRow(props: PieceInput<EventsRowEvents>) {
  return <EventsRowView {...useEventsRow(props)} />;
}
